/**
 * Feather Icons Utility for React
 * 
 * This utility helps initialize Feather icons in React components
 * since the Vuexy template uses data-feather attributes
 */

export const initFeatherIcons = () => {
  // Check if feather is available globally
  if (window.feather) {
    try {
      window.feather.replace();
    } catch (error) {
      console.warn('Feather icons initialization failed:', error);
    }
  }
};

/**
 * Hook to initialize Feather icons when component mounts
 * Usage: useFeatherIcons();
 */
export const useFeatherIcons = () => {
  const React = require('react');
  
  React.useEffect(() => {
    initFeatherIcons();
  }, []);
};

/**
 * Component wrapper that initializes Feather icons
 * Usage: <FeatherIcon icon="user" className="icon-class" />
 */
export const FeatherIcon = ({ icon, className = '', size = 16, ...props }) => {
  const React = require('react');
  const iconRef = React.useRef(null);

  React.useEffect(() => {
    if (iconRef.current && window.feather) {
      window.feather.replace();
    }
  }, [icon]);

  return (
    <i
      ref={iconRef}
      data-feather={icon}
      className={className}
      style={{ width: size, height: size }}
      {...props}
    />
  );
};

export default { initFeatherIcons, useFeatherIcons, FeatherIcon };
